import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { CheckoutService } from '../../core/services/checkout.service';

@Component({
  selector: 'app-checkout-cancel',
  imports: [RouterLink],
  template: `
    <div class="container dd-checkout-cancel">
      <h1 class="font-title">Checkout cancelled</h1>
      <p>Your payment was not completed. Your cart is still available.</p>
      <p>
        <a class="button" routerLink="/checkout">Return to checkout</a>
        <a class="button" routerLink="/shop">Continue shopping</a>
      </p>
    </div>
  `
})
export class CheckoutCancelComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly checkout = inject(CheckoutService);

  ngOnInit(): void {
    const sessionId =
      this.route.snapshot.queryParamMap.get('session_id') ??
      this.route.snapshot.queryParamMap.get('sessionId');

    if (!sessionId) {
      return;
    }

    this.checkout.cancelSession(sessionId).subscribe({ error: () => undefined });
  }
}
